export class BinToBulkRequest {
	pickingLabelR: number
	outboundCases: {
		subDivisionUidD: number
	};

	constructor() {
		this.outboundCases = {
			subDivisionUidD: 0
		};
	}
}
